<template>
    <div>

        <div class="card mb-4">
            <div class="card-body">
                <button type="button" class="btn btn-sm btn-secondary" @click="addSection">
                    <i class="fa fa-plus-circle"></i> Add Section
                </button>
                <button type="button" class="btn btn-sm btn-warning" @click="show_preview = true">
                    <i class="fa fa-eye"></i> Preview
                </button>
                <button type="button" class="btn btn-sm btn-success" @click="saveCustomFields()" :disabled="saving" v-if="show_save">
                    <i class="fa fa-floppy-o"></i> Save
                </button>
            </div>
        </div>

        <template v-for="(section, key) in sections">
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-8 col-12 form-inline">
                            <div class="form-group">
                                <label class="mr-3 text-muted">Section Name:</label>
                                <b-form-input v-model="section.section_name" placeholder="Enter Section Name" size="sm" style="min-width: 200px;" />
                            </div>
                            <div class="form-group ml-2" v-if="personnelOptions.length > 0">
                                <label class="mr-3 text-muted">Assign To:</label>
                                <b-form-select v-model="section.personnel_field_id" :options="personnelOptions" size="sm" />
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="float-right">
                                <button class="btn btn-sm btn-light" @click="section.show_body = !section.show_body" :title="(section.show_body ? 'Hide' : 'Show') + ' Section Fields'">
                                    <i :class="'fa fa-caret-' + (section.show_body ? 'up' : 'down')"></i>
                                </button>
                                <button class="btn btn-sm btn-light" @click="addField(section, key)" title="Add Field">
                                    <i class="fa fa-plus-circle text-success"></i>
                                </button>
                                <button class="btn btn-sm btn-light" @click="sections.splice(key, 1)" title="Delete Section">
                                    <i class="fa fa-trash text-danger"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{'card-body bg-light': true, 'd-none': !section.show_body}">

                    <div class="alert alert-danger"  v-if="errors['sections.'+key] && section.fields.length == 0">
                        <strong>Validation Errors:</strong>
                        <ul>
                            <li v-for="err in errors['sections.'+key]">{{ err }}</li>
                        </ul>
                    </div>

                    <div class="alert alert-danger"  v-if="errors['covid_fields.'+key]">
                        <strong>Validation Errors:</strong>
                        <ul>
                            <li v-for="err in errors['covid_fields.'+key]">{{ err }}</li>
                        </ul>
                    </div>

                    <div v-if="section.fields.length == 0" style="border: 1px dashed #ccc; padding: 10px 20px; text-align: center; height: 50px; line-height: 50px; background: #fff;">
                        <p style="display: inline-block; vertical-align: middle; line-height: normal; color: #ccc;">
                            Click the
                            <button class="btn btn-sm btn-link" @click="addField(section, key)" title="Add Field">
                                <i class="fa fa-plus-circle text-success"></i>
                            </button>
                            in the Section Heading to start adding fields
                        </p>
                    </div>
                    <div>
                        <div class="card mb-2" v-for="(field, elemKey) in section.fields" :key="field.id">
                            <div :class="{'card-header': true, 'text-danger': errors[field.id]}">
                                <div class="row">
                                    <div class="col-md-6 col-12 form-inline">
                                        <span class="mr-2">{{ field.label || ''}}: <span class="text-muted" title="This is the field's type.">{{ field.type }}</span></span>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="float-right">
                                            <input type="text" :value="field.order" class="form-control form-control-sm d-inline-block" placeholder="Field Order" style="width: 65px" title="Field Order" @input="setFieldOrder(field.id, $event)" />
                                            <button class="btn btn-sm btn-light" @click="toggleField(field.id)" :title="(field.show_body ? 'Hide' : 'Show') + ' Field Options'">
                                                 <i :class="'fa fa-caret-' + (field.show_body !== true ? 'down' : 'up')"></i>
                                            </button>
                                            <button class="btn btn-sm btn-light" @click="section.fields.splice(elemKey, 1)" title="Delete Field">
                                                <i class="fa fa-trash text-danger"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div :class="{'card-body': true, 'd-none': (!field.show_body || field.show_body == false)}"> -->
                            <div :class="{'card-body': true, 'd-none': (field.show_body == false)}">

                                <div class="form-group row mb-2" v-if="errors[field.id]">
                                    <div class="col-sm-10 offset-sm-1">
                                        <div class="alert alert-danger">
                                            <strong>Validation Errors:</strong>
                                            <ul>
                                                <li v-for="err in errors[field.id]">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Only Render This Field If:</label>
                                    <div class="col-sm-8 pt-2">
                                        <b-form-select v-model="field.parent_field_id" :options="conditionalFieldOptions(field.id)" size="sm">
                                            <template v-slot:first>
                                                <option :value="null">-- Select A Parent Field. Leave Blank to Always Show this Field --</option>
                                            </template>
                                        </b-form-select>
                                        <b-form-select v-if="field.parent_field_id" v-model="field.parent_field_value" :options="conditionalFieldValues(field.parent_field_id)" size="sm" class="mt-2">
                                            <template v-slot:first>
                                                <option :value="null">-- Select A Value --</option>
                                            </template>
                                        </b-form-select>
                                    </div>
                                </div>

                                <template v-if="field.type != 'Paragraph' && field.type != 'Heading'">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Required:</label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.is_required" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                                        </div>
                                    </div>
                                    <div class="form-group row" v-if="asset_type === 'Employee'">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Show on Public QR Profile:</label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.enable_public_view" :value="1" :unchecked-value="0" plain>
                                                <small class="text-info">If Checked, this field will be visible on the Employees' Public QR Code Page</small>
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                </template>

                                <div class="form-group row" v-if="field.type != 'Paragraph'">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Label:</label>
                                    <div class="col-sm-8">
                                        <b-form-input v-model="field.label" placeholder="Enter a Field Label" size="sm" class="mr-2" />
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Help Text:</label>
                                    <div class="col-sm-8">
                                        <b-form-input v-model="field.help_text" placeholder="Enter Some Help Text for the Field" size="sm" />
                                    </div>
                                </div>

                                <div class="form-group row" v-if="('placeholder' in field)">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Placeholder:</label>
                                    <div class="col-sm-8">
                                        <b-form-input v-model="field.placeholder" placeholder="Enter a Placeholder Label" size="sm" />
                                    </div>
                                </div>

                                <div class="form-group row" v-if="field.type === 'Date'">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Default to Current Date:</label>
                                    <div class="col-sm-8 pt-2">
                                        <b-form-checkbox v-model="field.default_current_date" :value="1" :unchecked-value="0" plain>
                                            If Enabled, this field will have a default value of the current date.
                                        </b-form-checkbox>
                                    </div>
                                </div>


                                <template v-if="field.type == 'Dropdown'">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Allow Multiple:</label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.allow_multiple" :value="true" :unchecked-value="false" plain>Allow Multiple Selections</b-form-checkbox>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="field.type == 'Dropdown'">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                                            Options:<br>
                                            <a href="javascript:void(0)" @click="$set(field.options, `field-${new Date().getTime()}`)">Add Option <i class="fa fa-plus-circle"></i></a>
                                        </label>
                                        <div class="col-sm-8">
                                            <div v-for="(option, key) in field.options" class="form-inline mb-2">
                                                <b-form-input v-model="field.options[key]" placeholder="Enter Option" size="sm" />

                                                <a href="jvascript:void(0)" class="text-danger ml-2" v-on:click="deleteOption(field.id, key)"><i class="fa fa-trash"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="field.type == 'Radio' || field.type == 'Checkbox'">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Vertical Display:</label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.display_vertical" :value="true" :unchecked-value="false" plain>Display the options vertically. Default is inline.</b-form-checkbox>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Alphabetize Options:</label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.alphabetize_options" :value="true" :unchecked-value="false" plain>If checked, the options below will be alphabetized.</b-form-checkbox>
                                        </div>
                                    </div>
                                    <!-- <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Enable "Other":</label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.enable_other" :value="true" :unchecked-value="false" plain>Let users to enter an unlisted option</b-form-checkbox>
                                        </div>
                                    </div> -->
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                                            Options:<br>
                                            <a href="javascript:void(0)" @click="$set(field.options, `field-${new Date().getTime()}`)">Add Option <i class="fa fa-plus-circle"></i></a>
                                        </label>
                                        <div class="col-sm-8">
                                            <div v-for="(option, key) in field.options" class="form-inline">
                                                <!-- <span class="mr-2">Option {{ key + 1 }}:</span> -->
                                                <b-form-input v-model="field.options[key]" placeholder="Enter Option" size="sm" />
                                                <button type="button" class="btn btn-link text-danger"  v-on:click="deleteOption(field.id, key)"><i class="fa fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="field.type == 'File'">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Allow Multiple:</label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.allow_multiple" :value="true" :unchecked-value="false" plain>Allow Multiple Files</b-form-checkbox>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Allowed File Types:</label>
                                        <div class="col-sm-8">
                                            <div class="text-info mb-1">-- Leave Unchecked to Allow All File Types --</div>
                                            <b-form-checkbox-group v-model="field.file_types" stacked plain :options="fileTypeOptions"></b-form-checkbox-group>
                                        </div>
                                    </div>
                                </template>

                                <div class="form-group row" v-if="field.type == 'Textarea'">
                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Rich Text:</label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="field.enable_rich_text" :value="true" :unchecked-value="false" plain>
                                            Enable Rich Text
                                        </b-form-checkbox>
                                        <p>This will activate the rich text editor that allows users to bold, highlight, list, and edit text.</p>
                                    </div>
                                </div>

                                <template v-if="field.type == 'Number'">
                                    <div class="form-group row"">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Min:</label>
                                        <div class="col-sm-8">
                                            <b-form-input v-model="field.min" placeholder="Enter Min Value" size="sm"></b-form-input>
                                        </div>
                                    </div>
                                    <div class="form-group row"">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Max:</label>
                                        <div class="col-sm-8">
                                            <b-form-input v-model="field.max" placeholder="Enter Max Value" size="sm"></b-form-input>
                                        </div>
                                    </div>
                                    <div class="form-group row"">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Step:</label>
                                        <div class="col-sm-8">
                                            <b-form-input v-model="field.step" placeholder="Enter Step Value" size="sm"></b-form-input>
                                        </div>
                                    </div>
                                </template>

                                <!-- <template v-if="field.type == 'Employee' || field.type == 'Equipment' || field.type == 'Jobsite' || field.type == 'User'">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right"></label>
                                        <div class="col-sm-8 pt-2">
                                            <b-form-checkbox v-model="field.allow_multiple" :value="true" :unchecked-value="false" plain>Allow Multiple Selections</b-form-checkbox>
                                        </div>
                                    </div>
                                </template> -->

                                <template v-if="field.type == 'Paragraph'">
                                    <div class="form-group row"">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Block Text:</label>
                                        <div class="col-sm-8">
                                            <b-form-textarea v-model="field.text" placeholder="Enter Block Text" rows="5"></b-form-textarea>
                                        </div>
                                    </div>
                                    <div class="form-group row"">
                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Background Color:</label>
                                        <div class="col-sm-8">
                                            <b-form-radio-group plain v-model="field.color">
                                                <b-form-radio :value="null">
                                                    <i class="fa fa-square-o"></i> -- None --
                                                </b-form-radio><br/>
                                                <b-form-radio value="primary">
                                                    <i class="fa fa-square text-primary"></i> Primary
                                                </b-form-radio><br/>
                                                <b-form-radio value="secondary">
                                                    <i class="fa fa-square text-secondary"></i> Secondary
                                                </b-form-radio><br/>
                                                <b-form-radio value="info">
                                                    <i class="fa fa-square text-info"></i> Info
                                                </b-form-radio><br/>
                                                <b-form-radio value="warning">
                                                    <i class="fa fa-square text-warning"></i> Warning
                                                </b-form-radio><br/>
                                                <b-form-radio value="success">
                                                    <i class="fa fa-square text-success"></i> Success
                                                </b-form-radio><br/>
                                                <b-form-radio value="danger">
                                                    <i class="fa fa-square text-danger"></i> Danger
                                                </b-form-radio><br/>
                                                <b-form-radio value="light">
                                                    <i class="fa fa-square text-light"></i> Light
                                                </b-form-radio><br/>
                                                <b-form-radio value="dark">
                                                    <i class="fa fa-square text-dark"></i> Dark
                                                </b-form-radio><br/>
                                            </b-form-radio-group>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <p class="mt-2">
                            <a href="javascript:void(0)" @click="addField(section, key)" style="display: block; text-align: center; padding: 6px 8px; border: 1px dashed #ccc;">-- <i class="fa fa-plus-circle text-success"></i> Add a New Field --</a>
                        </p>
                    </div>
                </div>
            </div>
        </template>

        <!-- Modal Component -->
        <b-modal v-model="show_preview" title="Form Preview" size="lg" no-fade :no-close-on-backdrop="true" ok-only ok-variant="secondary" ok-title="Close">

            <incident-sections-builder :sections="previewSections"></incident-sections-builder>

        </b-modal>

        <b-modal v-model="show_fields" title="Add Field Preview" size="lg" no-fade :no-close-on-backdrop="true" ok-variant="success" ok-title="Add Field" @ok="fieldAdded">

            <b-form-radio-group plain v-model="new_field">
                <strong>Standard Fields</strong>
                <ul class="list-group mb-4 bg-white">
                    <li class="list-group-item" v-for="field in fields" :key="field.id">
                        <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                    </li>
                </ul>

                <strong>Formatted Fields</strong>
                <ul class="list-group mb-4 bg-white">
                    <li class="list-group-item" v-for="field in formattedFields" :key="field.id">
                      <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                    </li>
                </ul>

                <strong>Lookup Fields - These are pulled from your lists of data.</strong>
                <ul class="list-group mb-4 bg-white">
                    <li class="list-group-item" v-for="field in lookUpFields" :key="field.id">
                      <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                    </li>
                </ul>

                <strong>Helpers - Insert Help Messages or Reminders for Users filling out your form.</strong>
                <ul class="list-group bg-white">
                    <li class="list-group-item" v-for="field in helperFields" :key="field.id">
                      <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                    </li>
                </ul>
            </b-form-radio-group>

        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            starting_sections: {
                type: Array,
                required: false,
                default: null,
            },

            show_save: {
                type: Boolean,
                required: false,
                default: true,
            },

            personnel: {
                type: Array,
                default: null,
            },

            asset_type: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                saving: false,
                loading: true,
                show_preview: false,
                show_fields: false,
                sections: [],
                editing_section: null,
                new_field: null,
                errors: [],

                fields: [
                    {id: 1, type: 'Text', placeholder: '', parent_field_id: null},
                    {id: 2, type: 'Dropdown', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 3, type: 'Radio', parent_field_id: null, options: {}, display_vertical: false, enable_other: false},
                    {id: 4, type: 'Checkbox', parent_field_id: null, options: {}, display_vertical: false, enable_other: false, allow_multiple: false},
                    {id: 5, type: 'Textarea', parent_field_id: null, placeholder: '', enable_rich_text: false},
                    {id: 18, type: 'File', parent_field_id: null, placeholder: ''},
                ],
                formattedFields: [
                    {id: 6, type: 'Date', parent_field_id: null, placeholder: '', format: 'MM/DD/YYYY'},
                    {id: 7, type: 'Time', parent_field_id: null, placeholder: ''},
                    {id: 8, type: 'Email', parent_field_id: null, placeholder: ''},
                    {id: 9, type: 'Phone', parent_field_id: null, placeholder: '', format: 'XXX-XXX-XXXX'},
                    {id: 10, type: 'Number', parent_field_id: null, placeholder: '', min: null, max: null, step: null},
                ],
                helperFields: [
                    {id: 12, type: 'Heading', parent_field_id: null, tag: 'h1'},
                    {id: 13, type: 'Paragraph', parent_field_id: null, color: 'info', text: ''},
                ],
                lookUpFields: [
                    {id: 14, type: 'Employee', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 15, type: 'Equipment', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 16, type: 'Jobsite', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 17, type: 'User', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                ],

                file_types: {
                    'csv': 'CSV',
                    'doc': 'DOC',
                    'docx': 'DOCX',
                    'gif': 'GIF',
                    'pdf': 'PDF',
                    'png': 'PNG',
                    'jpeg': 'JPEG',
                    'jpg': 'JPG',
                    'tiff': 'TIFF',
                    'xls': 'XLS',
                    'xlsx': 'XLSX',
                },
            }
        },

        watch: {
            personnel(newVal, oldVal){

            },
        },

        computed: {
            previewSections(){
                //Setup
                var sections = [];

                //Loop through and build lists
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Close it
                    var sec = JSON.parse(JSON.stringify(this.sections[i]));

                    //Unset the base section
                    delete sec.base_section;

                    //Push onto options
                    sections.push(sec);
                }

                //Send it
                return sections;
            },

            parentFields(){
                //Build based on the list of sections and their fields
                var parentFields = [];

                //Loop through the sections
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through the sections
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the type
                        if(this.sections[i].fields[j].type != 'Dropdown' && this.sections[i].fields[j].type != 'Radio' && this.sections[i].fields[j].type != 'Checkbox')
                        {
                            continue;
                        }

                        //Add the Option
                        parentFields.push({value: this.sections[i].fields[j].id, text: (this.sections[i].fields[j].label ? this.sections[i].fields[j].label : this.sections[i].fields[j].id)});
                    }
                }

                //SEnd it
                return parentFields;
            },

            fileTypeOptions(){
                //Setup
                var options = [];

                //Setup
                const keys = Object.keys(this.file_types);

                //Loop through and build lists
                for(var i = 0; i < keys.length; i++)
                {
                    //Push onto options
                    options.push({value: keys[i], text: this.file_types[keys[i]]});
                }

                //Send ti
                return options;
            },

            personnelOptions(){
                //Check if personnel is not empty
                if(this.personnel == null || this.personnel.length === 0)
                {
                    return [];
                }

                //Build the Options
                var options = [
                    {value: null, text: '-- Creator (Default) --'}
                ];

                //Loop and Build
                for (var i = 0; i < this.personnel.length; i++)
                {
                    //Append it
                    options.push({value: this.personnel[i].id, text: this.personnel[i].field_label});
                }

                //Send it
                return options;
            },
        },

        methods: {
            saveCustomFields(){
                //Emit it
                this.$emit('customFieldsSaved', this.sections);
            },

            //Add a Section
            addSection(){
                //Data
                var new_section = {
                    id: 'section-' + new Date().getTime(),
                    section_name: '',
                    fields: [],
                    show_body: true,
                    base_section: null,
                };

                //Check for Personnel
                if(this.personnelOptions.length > 0)
                {
                    //Set the field
                    new_section.personnel_field_id = null;
                }

                //Push
                this.sections.push(new_section);
            },

            addField(section, key){
                //Setter
                this.show_fields = true;

                //Adding to section
                this.editing_section = key;
            },

            conditionalFieldOptions(fieldId){
                //Clone it
                var options = JSON.parse(JSON.stringify(this.parentFields));

                //Unset the ID from the Conditional Fields
                for(var i = 0; i < options.length; i++)
                {
                    //Check the ID
                    if(fieldId == options[i].value)
                    {
                        //Remove the Option
                        options.splice(i, 1);
                    }
                }

                //Send ti
                return options;
            },

            conditionalFieldValues(parentFieldId){
                //Setup
                var options = [];

                //Get the fields parent_field_id
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through the sections
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the ID
                        if(parentFieldId == this.sections[i].fields[j].id)
                        {
                            //Add All the Options
                            options = this.sections[i].fields[j].options;
                        }
                    }
                }

                //Send it
                return options;
            },

            setFieldOrder(fieldId, event){
                //SEtup
                var newOrder = parseInt(event.target.value);

                //Get the fields parent_field_id
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Check the value?
                    if(newOrder < 0 || newOrder >= this.sections[i].fields.length)
                    {
                        //Stop here
                        this.$toastr.error('Invalid Order#, the order must be between 0 and ' + this.sections[i].fields.length);

                        //Return
                        return;
                    }

                    //Build a list of available order#
                    var orderNumbers = [];

                    //Loop and build
                    for(var t = 0; t < this.sections[i].fields.length; t++)
                    {
                        //Exclude the newOrder
                        if(t != newOrder)
                        {
                            orderNumbers.push(t);
                        }
                    }

                    //Loop through the sections
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the ID
                        if(fieldId == this.sections[i].fields[j].id)
                        {
                            //Set the Order
                            this.sections[i].fields[j].order = newOrder;
                        }
                        else
                        {
                            //Pop the first value off the available order numbers
                            this.sections[i].fields[j].order = orderNumbers[0];

                            //Remove the order number
                            orderNumbers.splice(0, 1);
                        }
                    }

                    //Reorder ALL section fields
                    this.sections[i].fields.sort((a, b) => (a.order > b.order) ? 1 : -1);
                }
            },

            fieldAdded(bvEvt) {
                //Make sure the user selected a field
                if(!this.new_field)
                {
                    //Alert the user
                    this.$toastr.warning('Select a Field to Add');

                    //Keep the modal open
                    bvEvt.preventDefault();

                    //Stop here
                    return;
                }

                //Get the field by ID and send it
                var fieldDefinition = this.getFieldById(this.new_field);

                //Clone it
                this.sections[this.editing_section].fields.push(this.cloneField(fieldDefinition, this.sections[this.editing_section].fields.length));

                //Reset
                this.editing_section = null;
                this.new_field = null;
            },

            getFieldById(id){
                //Loop through all
                for(var i = 0; i < this.fields.length; i++)
                {
                    //Check the if
                    if(id == this.fields[i].id)
                    {
                        return this.fields[i];
                    }
                }

                //Loop through all
                for(var i = 0; i < this.formattedFields.length; i++)
                {
                    //Check the if
                    if(id == this.formattedFields[i].id)
                    {
                        return this.formattedFields[i];
                    }
                }
                //Loop through all
                for(var i = 0; i < this.lookUpFields.length; i++)
                {
                    //Check the if
                    if(id == this.lookUpFields[i].id)
                    {
                        return this.lookUpFields[i];
                    }
                }

                //Loop through all
                for(var i = 0; i < this.helperFields.length; i++)
                {
                    //Check the if
                    if(id == this.helperFields[i].id)
                    {
                        return this.helperFields[i];
                    }
                }
            },

            //Clones a Field to a New Element
            cloneField(field, numExistingFields){
                //Setup
                var newField = JSON.parse(JSON.stringify(field));

                //Modify the field
                newField.id = field.type.toLowerCase() + '-' + new Date().getTime();
                newField.show_body = true;
                newField.core_field_key = null;
                newField.core_field_value = null;
                newField.order = numExistingFields;

                //Send it
                return newField;
            },

            toggleField(fieldId){
                //Loop through all
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through all
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the if
                        if(fieldId == this.sections[i].fields[j].id)
                        {
                            //Replace it to force a redraw
                            var field = this.sections[i].fields[j];

                            //SEtter
                            field.show_body = field.show_body === true || field.show_body === undefined ? false : true;

                            //Set
                            this.sections[i].fields.splice(j, 1, field);

                            //Set it
                            return;
                        }
                    }
                }
            },

            deleteOption(fieldId, optionIndex){
                //Loop through all
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through all
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the if
                        if(fieldId == this.sections[i].fields[j].id)
                        {
                            //Replace it to force a redraw
                            var field = this.sections[i].fields[j];

                            //IF the fields core_field_value is the option, set it to null
                            if(field.core_field_value == optionIndex)
                            {
                                field.core_field_value = null;
                            }

                            //Remove the option
                            delete field.options[optionIndex];

                            //Set
                            this.sections[i].fields.splice(j, 1, field);

                            //Set it
                            return;
                        }
                    }
                }
            },

            getSections(){
                //SEnd it
                return this.sections;
            },

            setErrors(errors){
                //Set it
                this.errors = errors;
            }
        },

        mounted() {
            //Check for Initial Settings
            if(this.starting_sections)
            {
                //Set it
                this.sections = this.starting_sections;
            }
        },
    }
</script>